import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, ROUTES, Routes} from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxDaterangepickerMd,DaterangepickerComponent } from 'ngx-daterangepicker-material';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { ComponentsSettingsService } from '../../services/components_settings.service';
import { LocalStorage, LocalStorageService } from 'ngx-store';

//Component
import { FuelComponent } from './fuel.component';
import { FuelLevyComponent } from './fuellevy/fuellevy.component';

//Module
import { ImageUploaderModule } from '../control/image-uploader/image-uploader.module';
import { SharedModule } from '../../shared/shared.module';
import { FileUploaderModule } from '../control/file-uploader/file-uploader.module';

// export const routes = [
//   { path: '', redirectTo: 'list', pathMatch: 'full'},
//   { path: 'list', component: FuelComponent, data: { breadcrumb: 'Fuel & Fuel Items' } },
//   { path: 'fuel_cards', loadChildren: () => import('./fuel_cards/fuel_cards.module').then(m => m.FuelCardsModule), data: { breadcrumb: 'Fuel Cards' }  },
      
// ];

@NgModule({
  imports: [
    CommonModule,
    //RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxPaginationModule,
    ImageUploaderModule,
    NgxDatatableModule,
    FileUploaderModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBackgroundColour: 'rgba(0, 0, 0, 0)',
      backdropBorderRadius: '4px',
      primaryColour: '#666666',
      secondaryColour: '#666666',
      tertiaryColour: '#666666'
    }),
    SharedModule,
    NgxDaterangepickerMd.forRoot(),

  ],
  declarations: [
    FuelComponent,
    FuelLevyComponent
  ],
  providers: [
    {
      provide: ROUTES,
      useFactory: (svc_component_settings : ComponentsSettingsService, svc_local_storage: LocalStorageService): Routes => {
        let routes: Routes = [];
        let tms_components = svc_local_storage.get('components');

        if(tms_components){
          tms_components.forEach(item=>{
            switch(item){
              case 'Fuel' :{  
                routes.push({ path: '', redirectTo: 'list', pathMatch: 'full'});
                routes.push({ path: 'list', component: FuelComponent, data: { breadcrumb: 'Fuel & Fuel Items' } });
              break};
            
              case 'Fuel Cards' :{ 
                routes.push({ path: 'fuel_cards', loadChildren: () => import('./fuel_cards/fuel_cards.module').then(m => m.FuelCardsModule), data: { breadcrumb: 'Fuel Cards' }  });
              break};

              case 'Fuel Levy' :{ 
                routes.push({ path: 'fuellevy', component: FuelLevyComponent, data: { breadcrumb: 'Fuel Levy' } });
              break};
            };
          }); 
        }
        return [...routes];
      },
      deps: [ComponentsSettingsService, LocalStorageService],
      multi: true
    }
],
  entryComponents: [DaterangepickerComponent]
})
export class FuelModule { }